import * as z from "zod";

export const updateAllCustomerWidgetSettings = {
  name: "updateAllCustomerWidgetSettings" as const,
  input: z.any(), // TODO: Add input schema
  output: z.null(),
};
